import Box from '@mui/material/Box';
import Link from '@mui/material/Link';
import Stack from '@mui/material/Stack';
import { styled } from '@mui/material/styles';
import Container from '@mui/material/Container';

import { Logo } from 'src/components/logo';


const FooterRoot = styled('footer')(({ theme }) => ({
    position: 'relative',
    backgroundColor: theme.vars.palette.background.default,
}));

export type FooterProps = React.ComponentProps<typeof FooterRoot>;

export function HomeFooter({ sx, ...other }: FooterProps) {
    return (
        <FooterRoot
            sx={[
                {
                    py: 5,
                    textAlign: 'center',
                },
                ...(Array.isArray(sx) ? sx : [sx]),
            ]}
            {...other}
        >
            <Container maxWidth="md">
                <Stack direction={{ xs: 'column', md: 'row' }} justifyContent="space-between" alignItems="center">
                    <Logo isSingle={false} />
                    <Box sx={{ mt: 1, typography: 'body1' }}>
                        <Link href="https://hellorecruiter.ai/privacy-policy" sx={{ color: 'common.black' }}> Privacy Policy </Link> |
                        <Link href="https://hellorecruiter.ai/privacy-policy" sx={{ color: 'common.black' }}> Terms of Service </Link> |
                        © All rights reserved. made by
                        <Link href="https://hellorecruiter.ai/"> Hello Recruiter </Link>
                    </Box>
                </Stack>
            </Container>
        </FooterRoot>
    );
}